<template>
  <div>
    <div v-if="initData.childInfo">
      <van-notice-bar left-icon="volume-o" :text="$t('notice.preview_model')" v-if="$route.name == 'previewWithdrawalBill'" />
      <div class="childDetail">
        <van-row type="flex" justify="end" class="mb-20" v-if="$route.name == 'previewWithdrawalBill'">
          <switch-lang color="#377ED7" />
        </van-row>
        <div class="flex align_items">
          <div><img :src="initData.childInfo.avatar" alt="" class="img44" /></div>
          <div class="flex1 ml-12">
            <div class="color3 font14 fontBold">{{ initData.childInfo.name }}</div>
            <div class="color6 font12">{{ initData.childInfo.className }}</div>
          </div>
        </div>
      </div>
      <div class="mt-16" style="margin: 16px" v-if="initData.status == -1"><van-notice-bar left-icon="info-o" wrapable :text="$t('withdrawal.pending_processing')" /></div>
      <div class="applicationInfo" v-else>
        <img src="../assets/dropoutConfirm.png" v-if="initData.status == 1" alt="" class="dropoutConfirm" />
        <div>
          <div class="send_memo" v-if="initData.financeInfo.send_memo != ''">
            <span v-html="initData.financeInfo.send_memo.replace(/\n/g, '<br>')"></span>
          </div>
          <div :class="index != 0 ? 'pt-24' : ''" v-for="(list, key, index) in viewTable" :key="index">
            <div v-if="key === 'enrollment'">
              <div class="subTitle">
                <img src="../assets/withdrawalEn.png" alt="" />
                <span>{{ initData.nodesTitle[key] }}</span>
              </div>
              <div class="mt-16 font14 color3">
                {{ list.balance == 0 ? $t("withdrawal.notXueji") : $t("withdrawal.notXueji") }} <span v-if="list.enrollment_state" class="xueji">{{ showTitle(list.enrollment_state) }}</span>
              </div>
              <div class="color9 font12 mt-8" v-if="list.prompt != ''">{{ list.prompt }}</div>
            </div>
            <div v-else-if="key === 'insurance'">
              <div class="subTitle">
                <img src="../assets/withdrawalIn.png" alt="" />
                <span>{{ initData.nodesTitle[key] }}</span>
              </div>
              <div class="mt-16 font14 color3">{{ list.balance == 0 ? $t("withdrawal.Insured3") : list.balance == 1 ? $t("withdrawal.Insured1") : list.balance == 2 ? $t("withdrawal.Insured2") : "" }}</div>
              <div v-if="list.balance == 1 || list.balance == 2" class="mt-8 color9 font12">{{ insuranceList[list.balance] }}</div>
            </div>
          </div>
          <div class="pt-24">
            <div class="subTitle">
              <img src="../assets/withdrawalBill.png" alt="" />
              <span>{{ $t("withdrawal.billDetails") }}</span>
            </div>
            <div class="refundInfo">
              <div class="flex1">
                <div class="mt-15">
                  <span class="refund" v-if="initData.financeInfo.total_amount == 0">{{ $t("withdrawal.Refunds") }}</span>
                  <span class="refund" v-else>{{ Math.sign(initData.financeInfo.total_amount) == 1 ? $t("withdrawal.Refunds") : $t("withdrawal.needPay") }}</span>
                </div>
                <div class="amount">{{ formatAmount(initData.financeInfo.total_amount) }}</div>
              </div>
              <img src="../assets/refunds.png" alt="" />
            </div>

            <div class="pt-24" v-for="(list, key, index) in amountTable" :key="index">
              <div class="titleAmount">
                <span v-if="key === 'tuition'">{{ $t("withdrawal.Tuition_Bal") }}</span>
                <span v-else> {{ initData.nodesTitle[key] }}</span>
              </div>
              <div v-if="key === 'it_equ'" class="flex refundItems">
                <div class="flex1 font14 color6">{{ list.balance == 1 ? $t("withdrawal.Returned") : list.balance == 2 ? $t("withdrawal.damage") : list.balance == 3 ? $t("withdrawal.Unreturned") : "" }}</div>
                <div class="font14 redColor" v-if="(list.balance == 2 || list.balance == 3) && list.balance_amount != ''">{{ $t("withdrawal.Owings") }} {{ formatAmount(list.balance_amount) }}</div>
              </div>
              <template v-else>
                <template v-if="list.goods.length">
                  <div v-for="(item, idx) in list.goods" :key="idx" :class="idx + 1 < list.goods.length ? 'bto' : ''">
                    <div class="flex refundItems">
                      <div class="flex1 font14 color6">
                        <div class="color3 font14" v-if="key === 'lunch' || key === 'bus'">{{ initData.nodesTitle[key] }}</div>
                        <div class="color3 font14" v-else-if="key === 'tuition'">{{ School_Fees[idx] }}</div>
                        <div class="color3 font14" v-else>{{ item.name }}</div>
                        <div class="color9 font12 mt-8" v-if="item.memo != ''">{{ $t("notice.memo") }}：{{ item.memo }}</div>
                      </div>
                      <div class="font14 redColor font14" v-if="!Array.isArray(list.balance)">{{ $t("withdrawal.Owings") }} {{ formatAmount(item.amount) }}</div>
                      <div class="font14 font14" v-else>
                        <span v-if="item.balance == '1'" class="redColor">{{ $t("withdrawal.Owings") }} {{ formatAmount(item.amount) }}</span>
                        <span v-if="item.balance == '0'" :class="item.amount == 0 ? '' : 'colorGreen'">{{ item.amount == 0 ? "" : $t("withdrawal.Refund") }} {{ formatAmount(item.amount) }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-else class="mt-16 font14 colorGreen">{{ $t("withdrawal.Fully_Reimbursed") }}</div>
              </template>
            </div>
          </div>
          <div class="bankInfo" v-if="Math.sign(initData.financeInfo.total_amount) == 1">
            <div class="bankTitle">{{ $t("withdrawal.bankNumber") }}</div>
            <div class="text-center font12 color6 bankDesc">{{ $t("withdrawal.bank_info") }}</div>
            <div class="bankCon">
              <div class="font14 color6 mb8 flex align_items">{{ $t("bankInfo.bankAddress") }}<span class="redImp">*</span></div>
              <van-field v-model="bank_info.bank_city" clearable :readonly="initData.status == 1 ? true : false" :placeholder="$t('global.please_input')" class="bgGray mt-10" />
              <div class="font14 color6 mb8 mt16 flex align_items">{{ $t("bankInfo.bankName") }}<span class="redImp">*</span></div>
              <van-field v-model="bank_info.bank_name" clearable :readonly="initData.status == 1 ? true : false" :placeholder="$t('global.please_input')" class="bgGray mt-10" />
              <div class="font14 color6 mb8 mt16 flex align_items">{{ $t("bankInfo.name") }}<span class="redImp">*</span></div>
              <van-field v-model="bank_info.bank_user" clearable :readonly="initData.status == 1 ? true : false" :placeholder="$t('global.please_input')" class="bgGray mt-10" />
              <div class="font14 color6 mb8 mt16 flex align_items">{{ $t("bankInfo.number") }}<span class="redImp">*</span></div>
              <van-field v-model="bank_info.bank_account" clearable :readonly="initData.status == 1 ? true : false" :placeholder="$t('global.please_input')" class="bgGray mt-10" />
            </div>
          </div>
          <div class="flex mt-24" v-if="initData.status != 1 && $route.name != 'previewWithdrawalBill'">
            <!-- <div class="flex1 mr-5"><van-button type="default" :disabled="initData.status == 2 ? true : false" block round @click="haveDoubts">有异议，我要反馈</van-button></div> -->
            <div class="flex1 ml-5">
              <van-button type="primary" block round color="#4D88D2" @click="signShowDailog()">{{ $t("withdrawal.process_completed") }}</van-button>
            </div>
          </div>
          <div v-if="initData.status == 1">
            <img :src="initData.financeInfo.sign_url" alt="" style="width: 100%; background: #fafafa; margin-top: 24px" />
          </div>
          <!-- <div class="flex tips mt-16" v-if="initData.status == 2">
            <van-icon name="info-o" size="16" class="icon colorYellow" />
            <div class="flex1 ml-10">
              <div class="colorYellow font14">账单有异议反馈成功，老师将与您取得联系</div>
              <div class="coloe3 mt-12 font12">{{ initData.financeInfo.feedback_memo }}</div>
              <div class="color6 font12 mt-8">
                —
                {{ initData.financeInfo.feedback_parent == "m" ? $t("coll.Mother") : $t("coll.Father") }}
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- <van-dialog v-model="queryShow" title="" show-cancel-button :before-close="beforeClose">
        <slot name="title">
          <div class="text-center fontBold pt-20">
            <div>反馈</div>
          </div>
        </slot>
        <div class="p16">
          <van-field v-model="message" :placeholder="$t('global.please_input')" class="bgGray mt-10" type="textarea" rows="3" />
          <div class="font12 color6 mt-12 mb-15">请简要描述反馈内容，老师将与您取得联系</div>
        </div>
      </van-dialog> -->
    </div>
    <div class="text-center pt-50 mt-50" v-if="initData.status == 99">
      <img class="img" src="../assets/completed.png" alt="" style="width: 200px" />
      <div class="font17 color3 fontBold mt-12">{{ $t("withdrawal.confirmed") }}</div>
    </div>
    <div class="signCon" v-if="signShow" @touchmove.prevent>
      <sign @click="baseImg"></sign>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast, Dialog, Tag, RadioGroup, Radio, DatetimePicker, ActionSheet, Popup } from "vant";
import {} from "vant";
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Popup);
import { childInfo, feedback, parentConfirm, withdrawalFinance } from "@/api/withdrawal";
import sign from "@/components/steps/sign";
import SwitchLang from "@/components/SwitchLang";

export default {
  name: "PTC",
  components: {
    sign: sign,
    "switch-lang": SwitchLang,
  },
  data() {
    return {
      appid: "",
      initData: {},
      currentDateCopy: "",
      currentDate: "",
      showDate: false,
      queryShow: false,
      message: "",
      withdrawal_where: "",
      withdrawal_where_memo: "",
      withdrawal_reason: "",
      withdrawal_reason_memo: "",
      withdrawal_unsatisfied: "",
      withdrawal_recommendations: "",
      withdrawal_contact_user: "",
      withdrawal_contact_name: "",
      withdrawal_contact_phone: "",
      base64: "",
      signShow: false,
      sign_pdf: "",
      sign_url: "",
      viewTable: {},
      amountTable: {},
      bank_info: {
        bank_city: "",
        bank_name: "",
        bank_user: "",
        bank_account: "",
      },
      School_Fees: [this.$t("withdrawal.School_Fees"), this.$t("withdrawal.Account_balance")],
      insuranceList: {
        1: "亲爱的家长您好，根据北京市社会医疗保险（一老一小）的要求，在校学生的社会医疗保险需要跟随学生的就读学校进行迁移。由于学生需要从启明星学校转出，我校将不再为其办理下一年度社会医疗保险的续保事宜。您孩子的社会医疗保险关系即日起将从本校转出，建议您尽快联系孩子的新学校或户口所在社区进行续保，以确保不会断保。",
        2: "亲爱的家长您好，根据北京市社会医疗保险（一老一小）的要求，学生的保险需要跟随学生的所在学校/学籍进行迁移。对于已经离校的学生，启明星学校原则上不再为学生办理一老一小保险的参保及续保手续。对于未到转出学籍窗口期，学生虽已离校，但学籍仍需暂时由我校代为保管的情况，需要家长知晓：1. 请家长在转出学籍窗口期尽快完成学籍转移，并同时联系校医室办理一老一小保险的转出。2. 由于学籍暂未转出原因，需要代管一老一小保险的最长代管期为一年，逾期将默认进行减员。3. 请家长主动联系校医室申请一老一小保险代管。未在学生转走一个月内联系校医室，学生的一老一小保险将默认进行减员。",
      },
    };
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background-color:#fff;");
  },
  created() {
    this.appid = this.$route.params.id;
    if (this.$route.name == "previewWithdrawalBill") {
      withdrawalFinance(this.appid, { token: this.$route.query.token }).then((res) => {
        this.initData = res.data;
        if (Math.sign(this.initData.financeInfo.total_amount) == 1) {
          if (this.initData.status == 1) {
            this.bank_info = {
              bank_city: this.initData.financeInfo.bank_city,
              bank_name: this.initData.financeInfo.bank_name,
              bank_user: this.initData.financeInfo.bank_user,
              bank_account: this.initData.financeInfo.bank_account,
            };
          } else {
            this.bank_info = this.initData.financeInfo.bank_info;
          }
        }
        if (this.initData.financeInfo.items) {
          for (let key in this.initData.financeInfo.items) {
            if (key === "enrollment" || key === "insurance") {
              this.viewTable[key] = this.initData.financeInfo.items[key];
            } else {
              this.amountTable[key] = this.initData.financeInfo.items[key];
            }
          }
        }
      });
    } else {
      this.getInit();
    }
  },
  watch: {},
  methods: {
    formatAmount(o_amount) {
      let amount = Number(o_amount);
      if (typeof amount !== "number" || isNaN(amount)) {
        return "";
      }
      try {
        return amount.toLocaleString("zh-CN", {
          style: "currency",
          currency: "CNY",
        });
      } catch (error) {
        return "";
      }
    },
    getInit() {
      childInfo(this.appid).then((res) => {
        this.initData = res.data;
        if (Math.sign(this.initData.financeInfo.total_amount) == 1) {
          if (this.initData.status == 1) {
            this.bank_info = {
              bank_city: this.initData.financeInfo.bank_city,
              bank_name: this.initData.financeInfo.bank_name,
              bank_user: this.initData.financeInfo.bank_user,
              bank_account: this.initData.financeInfo.bank_account,
            };
          } else {
            this.bank_info = this.initData.financeInfo.bank_info;
          }
        }
        if (this.initData.financeInfo.items) {
          for (let key in this.initData.financeInfo.items) {
            if (key === "enrollment" || key === "insurance") {
              this.viewTable[key] = this.initData.financeInfo.items[key];
            } else {
              this.amountTable[key] = this.initData.financeInfo.items[key];
            }
          }
        }
      });
    },
    haveDoubts() {
      this.queryShow = true;
    },
    showTitle(id) {
      const value = this.initData.config.enrollmentStateList.filter((item) => item.key == id);
      return value[0].value;
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        feedback({ app_id: this.appid, memo: this.message }).then((res) => {
          if (res.code == 0) {
            Toast(res.msg);
            this.getInit();
          }
          this.queryShow = false;
          done();
        });
      } else if (action === "cancel") {
        done(); //关闭
      }
    },
    signShowDailog() {
      if (Math.sign(this.initData.financeInfo.total_amount) == 1) {
        if (this.bank_info.bank_city == "") {
          Toast(this.$t("global.please_input") + this.$t("bankInfo.bankAddress"));
          return;
        } else if (this.bank_info.bank_name == "") {
          Toast(this.$t("global.please_input") + this.$t("bankInfo.bankName"));
          return;
        }
        if (this.bank_info.bank_user == "") {
          Toast(this.$t("global.please_input") + this.$t("bankInfo.name"));
          return;
        } else if (this.bank_info.bank_account == "") {
          Toast(this.$t("global.please_input") + this.$t("bankInfo.number"));
          return;
        }
      }
      document.body.style.overflow = "hidden";
      this.signShow = true;
    },
    baseImg(data) {
      const that = this;
      if (data != "cancel") {
        this.imgData = data;
        var pic = data.substring(data.indexOf(",") + 1);
        var url = "https://upload-z1.qiniup.com/putb64/-1";
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          // toast.clear()
          if (xhr.readyState == 4) {
            var resJson = JSON.parse(xhr.responseText);
            if (resJson.code == 0) {
              Vue.set(that, "sign_url", resJson.data.url);
              Vue.set(that, "sign_pdf", resJson.data.key);
              that.saveData();
            } else {
              Toast(resJson.msg);
            }
          }
        };
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/octet-stream");
        xhr.setRequestHeader("Authorization", "UpToken " + that.initData.financeInfo.sign_token);
        xhr.send(pic);
      } else {
        document.body.style.overflow = "";
        this.signShow = false;
      }
    },
    saveData() {
      let data = {};
      if (Math.sign(this.initData.financeInfo.total_amount) == 1) {
        data = {
          app_id: this.appid,
          sign_pdf: this.sign_pdf,
          bank_account: this.bank_info.bank_account,
          bank_city: this.bank_info.bank_city,
          bank_name: this.bank_info.bank_name,
          bank_user: this.bank_info.bank_user,
        };
      } else {
        data = {
          app_id: this.appid,
          sign_pdf: this.sign_pdf,
        };
      }
      parentConfirm(data).then((res) => {
        if (res.code == 0) {
          Toast(res.msg);
          this.getInit();
          document.body.style.overflow = "";
          this.signShow = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.fontBold {
  font-weight: bold;
}

.mt-12 {
  margin-top: 12px;
}

.mt-16 {
  margin-top: 16px;
}

.mt-24 {
  margin-top: 24px;
}

.pt-24 {
  padding-top: 24px;
}

.important {
  color: #d9534f;
}

.redColor {
  color: #ee0a24;
}

.colorBlue {
  color: #4d88d2;
}

.colorGreen {
  color: #45a367;
}

.img28 {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.align_items {
  align-items: center;
}

.childDetail {
  align-items: center;
  padding: 16px;
  background: #fff;

  .img44 {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
  }
}

.contact {
  padding: 0 0 0 16px !important;
  margin: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.appForms {
  margin: 16px;
  background: #fff;
  padding: 16px;

  .requiredIcon {
    align-items: center;
    font-weight: 500;
  }

  .selectCSs {
    padding: 12px 0;
    border-bottom: 1px solid #ebedf0;
    font-size: 14px;
    color: #333;
  }

  .inputCSs {
    border: 1px solid #ebedf0;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
  }

  .radioItems {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #ebedf0;
    border-radius: 8px;
    align-items: start;
  }
}

.submitBtn {
  padding: 5px 16px;
  background: #fff;
}

.applicationInfo {
  padding: 0 16px 16px;
  background: #fff;
  position: relative;
  // margin: 16px;

  .lineHeight {
    line-height: 1;
  }

  .dropoutConfirm {
    position: absolute;
    right: 0;
    top: -80px;
    width: 97px;
    height: 97px;
    z-index: 99;
  }

  .width16 {
    width: 16px;

    .itemsBg {
      width: 6px;
      height: 16px;
      background: #4d88d2;
      border-radius: 3px;
      display: inline-block;
    }
  }

  .mt-8 {
    margin-top: 8px;
  }

  .memo {
    padding: 12px;
    background: #f7f8fa;
    border-radius: 4px;
    font-size: 13px;
    color: #666;
  }

  .refundInfo {
    height: 86px;
    background: linear-gradient(131deg, #dee8ff 0%, #eff5ff 100%);
    border-radius: 12px;
    margin-top: 24px;
    position: relative;
    display: flex;

    .flex1 {
      flex: 1;
    }

    .refund {
      background: #476bf5;
      border-radius: 0px 199px 199px 0px;
      left: 0;
      margin-top: 12px;
      color: #fff;
      font-size: 14px;
      padding: 5px 12px;
      height: 14px;
    }

    .amount {
      font-size: 20px;
      padding-left: 16px;
      padding-top: 13px;
      font-weight: 600;
    }

    img {
      height: 100%;
    }
  }

  .refundItems {
    padding-top: 16px;
    align-items: center;
  }

  .bto {
    border-bottom: 1px solid #ebedf0;
    padding-bottom: 16px;
  }

  .tips {
    background: #fdf8f1;
    padding: 13px 16px;

    .colorYellow {
      color: #f5a429;
    }

    .icon {
      padding-top: 2px;
    }
  }

  .send_memo {
    padding: 16px;
    color: #333;
    font-size: 14px;
    background: #f7f8fa;
    border-radius: 4px;
    margin-bottom: 24px;
  }

  .subTitle {
    font-size: 15px;
    font-weight: 500;
    color: #4d88d2;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      margin-right: 6px;
    }
  }

  .xueji {
    color: #ed6a0c;
    background: rgba(237, 106, 12, 0.1);
    padding: 0 6px;
    border-radius: 10px;
    margin-left: 5px;
    font-size: 12px;
  }

  .titleAmount {
    background: #f7f8fa;
    border-radius: 12px;
    font-size: 14px;
    color: #323233;
    line-height: 20px;
    text-align: center;
    font-style: normal;
    padding: 2px 0;
  }

  .bankInfo {
    border-radius: 8px;
    border: 1px solid #d8e9ff;
    // padding:0 16px 16px;
    margin-top: 24px;

    .bankTitle {
      background: linear-gradient(180deg, #d4e7ff 0%, #ffffff 100%);
      padding: 12px 0 4px 0;
      text-align: center;
      font-size: 15px;
      border-radius: 7px 7px 0px 0px;
    }

    .bankDesc {
      padding: 0 16px 16px;
    }

    .bankCon {
      padding: 8px 16px 16px;

      .mt16 {
        margin-top: 16px;
      }

      .redImp {
        margin-left: 6px;
        height: 12px;
        color: #ee0a24;
      }
    }
  }
}
</style>
